<template>
  <div class="subject" :class="[isIndex ? 'is-index' : '']" :style="{backgroundColor: themeConfig && themeConfig.web_theme_background_color ? themeConfig.web_theme_background_color: 'none'}">
    <!-- 临时增加跳转 -->
    <a v-if="themeConfig && themeConfig.web_theme_top_img" href="javascript:void(0)"><img class="theme-top-img" @click="topImgClick" :src="themeConfig.web_theme_top_img" alt="" /></a>
    <!-- <a href="https://www.hebitv.com/news/searchResult?keywords=%E4%BA%8C%E5%8D%81%E5%A4%A7"><img src="/public/w/img/410600/ershida.jpg" style="min-width: 1140px; width: 100%;"></a> -->
   <div v-if="clientId == 320684" class="jdqz" style="background: url('/public/w/img/410600/znq.png') no-repeat top center;width: 100%;height: 576px !important;"></div>
    <div style="position: relative;">
      <LayoutHeader :channels="channels" :ads='ads' :showid="showid" :clientId='clientId' :apiOrigin="apiOrigin">
      </LayoutHeader>
      <div class="main clear  contents pt30">
        <slot name="main"></slot>
      </div>
      <div class="aside_img_lf" v-if="clientId == 320598">
      </div>
      <div class="aside_img_rh" v-if="clientId == 320598">
      </div>
    </div>

    <LayoutFooter :clientId='clientId'>
      <div slot="bottom">  
        <slot name="bottom"></slot>
      </div> 
    </LayoutFooter>
  </div>
</template>
<style lang="css">
  body {
    margin: 0 0px;
  }
  .is-index {
    -webkit-filter: grayscale(100%);
  }
  a {
    text-decoration: none;
  }
  .aside_img_rh, .aside_img_lf{
    width: calc((100vw - 1160PX)/2);
    height: 100px;
    position: absolute;
    z-index: 100;
    top: 0;
    height: 100%;
  }
  .aside_img_lf img, .aside_img_rh img {
    width: 100%;
    height: 100%;
  }
  .aside_img_rh{
    right: 0;
    /* background-image: url(/public/w/img/320598/newyear_02.png); */
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .aside_img_lf{
    left: 0;
    /* background-image: url(/public/w/img/320598/newyear_01.png); */
    background-size: 100%;
    background-repeat: no-repeat;
  }
</style>
<script>
  import axios from 'axios';
  import LayoutHeader from './header/header';
  import LayoutFooter from './footer/footer';
  export default {
    components: {
      LayoutHeader,
      LayoutFooter
    },
    data() {
      return {
        adShows: true,
        // 签名
        signatureObj: {},
        // 主题配置
        themeConfig: {},
        isIndex: false
      }
    },
    computed: {
      // isIndex() {
      //   if ((location.href == 'https://www.hebitv.com/news') || (location.href == 'https://www.hebitv.com/') || (location.href == 'https://www.hebitv.com') || (location.href == 'http://www.hebitv.com/news') || (location.href == 'http://www.hebitv.com/') || (location.href == 'http://www.hebitv.com')) {
      //     return true
      //   } else {
      //     return false
      //   }
      // }
    },
    props: {
      showid: {
        default: 0
      },
      clientId: {},
      ads: {

      },
      channels: {
        default: []
      },
      apiOrigin: {
        default: ''
      }
    },
    created() {
      var _time = new Date().getTime();
      if((_time > 1639324800000) && (_time < 1639411200000)) {
        document.getElementsByTagName('html')[0].style['-webkit-filter'] = 'grayscale(100%)';
      }
      // 签名
      this.signatureObj = window.getSignature()
      console.log('this.signatureObj', this.signatureObj, this.apiOrigin)
      // 获取网站配置
      this.initWebSetting()
    },
    methods: {
      // 获取网站配置
      initWebSetting() {
        const params = ''
        axios.get(`${this.apiOrigin}/v4/web-theme-config?timestamp=${this.signatureObj.timestamp}&nonce=${this.signatureObj.nonce}&signature=${this.signatureObj.signature}`).then(data => {
          console.log('回去网站配置', data)
          if (parseInt(data.data.data.web_theme_style) === 1) {
            this.themeConfig = data.data.data
            if (parseInt(data.data.data.web_theme_filter) === 2) {
              this.isIndex = true
            }
          }
        });
      },
      // 顶部图跳转
      topImgClick() {
        // window.location.href = 'http://www.hebitv.net/news/topic/733823'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// app/web/component/web/news-layout/main.vue